import { useEffect, useState } from "react";

export type BatchDeletePermissionLoader = () => Promise<boolean>;

export const useBatchDeletePermission = (loadPermission: BatchDeletePermissionLoader) => {
  const [canBatchDelete, setCanBatchDelete] = useState(false);

  useEffect(() => {
    let isActive = true;
    setCanBatchDelete(false);

    loadPermission()
      .then((allowed) => {
        if (isActive) setCanBatchDelete(allowed === true);
      })
      .catch(() => {
        if (isActive) setCanBatchDelete(false);
      });

    return () => {
      isActive = false;
    };
  }, [loadPermission]);

  return canBatchDelete;
};
